<div class="screen screen--detail">

  <header class="detail__hero ga-photo ga-photo--<%= e.photo %>">
    <% if ( e.images.length > 0 ) { %>
      <!-- The header image is the first of the list (set in the client-admin);
           tapping it opens the gallery at that image. -->
      <button class="detail__hero-photo" type="button" data-gallery="0" aria-label="<%= _lcs( 'Bild vergrößern' ) %>">
        <img class="detail__hero-img" src="<%= e.images[ 0 ].url %>" alt="<%= e.images[ 0 ].alt %>" />
      </button>
      <% if ( e.images.length > 1 ) { %>
        <span class="detail__hero-count"><i class="icon icon--image"></i> <%= e.images.length %></span>
      <% } %>
    <% } else { %>
      <i class="icon icon--<%= e.icon %> detail__hero-glyph"></i>
    <% } %>
    <div class="detail__hero-scrim"></div>
    <button class="detail__round" type="button" data-id="back" aria-label="<%= _lcs( 'Zurück' ) %>"><i class="icon icon--arrow-left"></i></button>
    <button class="detail__round detail__round--right" type="button" data-id="share" aria-label="<%= _lcs( 'Teilen' ) %>"><i class="icon icon--share-2"></i></button>
  </header>

  <div class="detail__body">
    <div class="detail__badges">
      <span class="badge <%= e.scope === 'own' ? 'badge--solid' : 'badge--accent' %>"><%= e.scope === 'own' ? _lcs( 'Vom Haus' ) : _lcs( 'Region' ) %></span>
      <span class="badge badge--brand"><%= e.cat %></span>
    </div>
    <h1 class="detail__title"><%= e.title %></h1>
    <% if ( e.subtitle ) { %><p class="detail__sub"><%= e.subtitle %></p><% } %>

    <div class="metarows">
      <div class="metarow">
        <span class="metarow__icon"><i class="icon icon--calendar-days"></i></span>
        <span class="metarow__text"><%= e.dateText %></span>
      </div>
      <div class="metarow">
        <span class="metarow__icon"><i class="icon icon--map-pin"></i></span>
        <span class="metarow__text">
          <%= e.dist ? e.loc + ' · ' + e.dist : e.loc %><% if ( e.address ) { %><br /><%= e.address %><% } %>
        </span>
      </div>
      <% if ( e.organizer ) { %>
      <div class="metarow">
        <span class="metarow__icon"><i class="icon icon--users"></i></span>
        <span class="metarow__text"><%= e.organizer %></span>
      </div>
      <% } %>
    </div>

    <% if ( e.description ) { %>
    <p class="detail__text"><%= e.description %></p>
    <% } %>

    <% if ( e.images.length > 1 ) { %>
    <h3 class="detail__subhead"><%= _lcs( 'Bilder' ) %></h3>
    <div class="gallery" data-id="gallery">
      <% e.images.forEach( function( img, i ) { %>
        <button class="gallery__thumb" type="button" data-gallery="<%= i %>" aria-label="<%= _lcs( 'Bild {i} von {total} vergrößern', { i: i + 1, total: e.images.length } ) %>">
          <img src="<%= img.url %>" alt="<%= img.alt %>" loading="lazy" />
        </button>
      <% } ); %>
    </div>
    <% } %>

    <% if ( e.facts.length > 0 ) { %>
    <h3 class="detail__subhead"><%= _lcs( 'Gut zu wissen' ) %></h3>
    <div class="checklist">
      <% e.facts.forEach( function( f ) { %>
        <div class="checklist__item"><i class="icon icon--<%= f.icon %>"></i><span><%= f.text %></span></div>
      <% } ); %>
    </div>
    <% } %>

    <% if ( e.directions ) { %>
    <h3 class="detail__subhead"><%= _lcs( 'Anreise' ) %></h3>
    <p class="detail__text"><%= e.directions %></p>
    <% } %>

    <% if ( e.dates.length > 0 ) { %>
    <h3 class="detail__subhead"><%= _lcs( 'Weitere Termine' ) %></h3>
    <div class="infolist infolist--dates">
      <% e.dates.forEach( function( d ) { %>
        <div class="infolist__row">
          <span class="infolist__icon"><i class="icon icon--calendar"></i></span>
          <span class="infolist__label"><%= d.text %></span>
          <span class="infolist__meta">
            <% if ( d.isCancelled ) { %><%= _lcs( 'abgesagt' ) %><% } else if ( d.isSoldOut ) { %><%= _lcs( 'ausverkauft' ) %><% } %>
          </span>
        </div>
      <% } ); %>
    </div>
    <% } %>

    <% e.links.forEach( function( l ) { %>
      <a class="btn btn--secondary btn--lg btn--block detail__link" href="<%= l.url %>" target="_blank" rel="noopener noreferrer">
        <i class="icon icon--<%= l.icon %>"></i> <%= l.label %>
      </a>
    <% } ); %>

    <button class="btn btn--primary btn--lg btn--block" type="button" data-id="add">
      <i class="icon icon--calendar-plus"></i> <%= _lcs( 'Zum Planer hinzufügen' ) %>
    </button>
  </div>


</div>
